export var NotificationEvent;
(function (NotificationEvent) {
    /** Triggered when SupplyTransfer.status.status === 'assigned' */
    NotificationEvent["APPOINTMENT_REMINDER"] = "notif_appointmentReminder";
    /** Triggered when a nurse arrives at a waypoint */
    NotificationEvent["ARRIVE_AT_WAYPOINT"] = "notif_arriveAtWaypoint";
    /**
     * Triggered when a nurse cancels a shift less than 24 hours before the shift
     * starts.
     */
    NotificationEvent["CANCELATION_ATTEMPT"] = "notif_cancelationAttempt";
    /**
     * Triggered when a user attempts to use a link with an expired token. The
     * user will be emailed the same link again, but with a new token.
     *
     * Example paths that may be sent:
     * - `/resetPassword?token=...`
     * - `/joinOffice?token=...`
     * - `/finishSignUp?redirect=%2Fjob%2Fabc123&token=...`
     */
    NotificationEvent["NEW_TOKEN_LINK"] = "notif_newTokenLink";
    /**
     * Triggered when Waypoint.status.status changed to 'transitWaypoint' and
     * Waypoint.transitInfo.delayInfo is not set. Typically this would be because
     * the nurse just clicked "Drive".
     *
     * Used to send a notification to the users on a waypoint about the appointment
     */
    NotificationEvent["NURSE_IN_TRANSIT"] = "notif_nurseInTransit";
    /**
     * Triggered when Waypoint.status.status === 'transitWaypoint' and
     * Waypoint.transitInfo.delayInfo was just added. Typically this would be
     * because the nurse just clicked "I’m running late".
     */
    NotificationEvent["NURSE_RUNNING_LATE"] = "notif_nurseRunningLate";
    /** The order status updates to canceled */
    NotificationEvent["ORDER_CANCELED"] = "notif_orderCanceled";
    /** A draft order is either created or updated */
    NotificationEvent["ORDER_INITIATED"] = "notif_orderInitiated";
    /** An order is created for the first time | The draft order is finalized to become a full order */
    NotificationEvent["ORDER_SUBMITTED"] = "notif_orderSubmitted";
    /** Triggered when a patient's date of birth is validated */
    NotificationEvent["PATIENT_DOB_VALIDATED"] = "notif_patientDOBValidated";
    /** The procedure status updates to canceled */
    NotificationEvent["PROCEDURE_CANCELED"] = "notif_procedureCanceled";
    /** The procedure status updates to failed */
    NotificationEvent["PROCEDURE_FAILED"] = "notif_procedureFailed";
    /** The procedure status updates to completed */
    NotificationEvent["PROCEDURE_COMPLETED"] = "notif_procedureCompleted";
    /**
     * If a waypoint gets completed, and any of the procedures have
     * `disallowRescheduling` set to false, this event is triggered.
     */
    NotificationEvent["RESCHEDULING_EVENT"] = "notif_reschedulingEvent";
    NotificationEvent["RESET_PASSWORD"] = "notif_resetPassword";
    NotificationEvent["RESULT_UPLOAD"] = "notif_resultUploaded";
    /** Used to resend the scheduling link with a selected contact method(s) */
    NotificationEvent["RETRIGGER_SCHEDULING_EVENT"] = "notif_retriggerSchedulingEvent";
    /** The shipment status is updated to delivered */
    NotificationEvent["SAMPLES_DELIVERED"] = "notif_samplesDelivered";
    /** The waypoint action status is updated to COMPLETE */
    NotificationEvent["SAMPLES_SUBMITTED"] = "notif_samplesSubmitted";
    /**
     * A draft waypoint has been created and is ready to schedule
     */
    NotificationEvent["SCHEDULING_EVENT"] = "notif_schedulingEvent";
    NotificationEvent["SET_ITINERARY_LEAVE_BY"] = "notif_setItineraryLeaveBy";
    /**
     * If shift has been assigned 2h before timeInfo.startTime, we need this one
     * to fire right at assignment with ETA (replacement for
     * notif_setItineraryLeaveBy but with shorter turnaround)
     */
    NotificationEvent["SET_ITINERARY_LEAVE_BY_INSTANT"] = "notif_setItineraryLeaveByInstant";
    NotificationEvent["SET_PASSWORD"] = "notif_setPassword";
    NotificationEvent["SHIFT_CANCELED"] = "notif_shiftCanceled";
    NotificationEvent["SHIFT_STAFFING_ASSIGNMENT"] = "notif_shiftStaffingAssignment";
    /** Triggered when a nurse is assigned to a shift */
    NotificationEvent["SHIFT_ASSIGNMENT"] = "notif_shiftAssignment";
    /** Triggered when a nurse starts a shift */
    NotificationEvent["SHIFT_CHECK_IN"] = "notif_shiftCheckIn";
    /**
     * Triggered when a shift is set to failed. This action may have been
     * completed automatically at the end time of a shift.
     */
    NotificationEvent["SHIFT_FAILURE"] = "notif_shiftFailure";
    /** Triggered when a shift offer is created */
    NotificationEvent["SHIFT_OFFER"] = "notif_shiftOffer";
    /**
     * Tirggered when a nurse accepts a shift offer
     * Doesn't necessarily mean the nurse has been assigned to the shift yet, as
     * we display shift offeres to nurses even if they are assigned to someone else.
     */
    NotificationEvent["SHIFT_OFFER_ACCEPTED"] = "notif_shiftOfferAccepted";
    /** Triggered for all `Shift.nursesOffered` when a shift is canceled */
    NotificationEvent["SHIFT_OFFER_CANCELED"] = "notif_shiftOfferCanceled";
    /** Triggered when a nurse declines a shift offer */
    NotificationEvent["SHIFT_OFFER_DECLINED"] = "notif_shiftOfferDeclined";
    /** Triggered when a shift offer is rescinded */
    NotificationEvent["SHIFT_OFFER_RESCINDED"] = "notif_shiftOfferRescinded";
    /** Triggered when a shift is unassigned */
    NotificationEvent["SHIFT_UNASSIGN"] = "notif_shiftUnassign";
    NotificationEvent["SHIFT_OFFER_TAKEN"] = "notif_shiftOfferTaken";
    /**
     * A nurse is unassigned from a shift due to 'canceling' it on their end over
     * 24 hours before the shift starts.
     */
    NotificationEvent["SHIFT_REASSIGNMENT"] = "notif_shiftReassignment";
    /** Triggered when `Shipment` created and when its status is updated */
    NotificationEvent["SHIPMENT_STATUS_UPDATE"] = "notif_shipmentStatusUpdate";
    /** Triggered when SupplyShipment.status.status === 'delivered' */
    NotificationEvent["SUPPLIES_DELIVERED"] = "notif_suppliesDelivered";
    /** Triggered when DraftWaypoint.status === 'finalized and is a brick and mortar visit */
    NotificationEvent["BNM_VISIT_SCHEDULED"] = "notif_bnmVisitScheduled";
    NotificationEvent["VISIT_CANCELED"] = "notif_visitCanceled";
    /** Triggered when DraftWaypoint.status === 'rejected */
    NotificationEvent["VISIT_REJECTED"] = "notif_visitRejected";
    /** Triggered when DraftWaypoint.status === 'finalized and is a mobile visit */
    NotificationEvent["VISIT_SCHEDULED"] = "notif_visitScheduled";
    NotificationEvent["WAYPOINT_ACTION_COMPLETE"] = "notif_waypointActionComplete";
    /**
     * Triggers when user clicks on the 'keep driving' button in the location
     * deviation modal
     */
    NotificationEvent["WAYPOINT_ARRIVAL_BLOCKER"] = "notif_waypointArrivalBlocker";
    /**
     * A waypoint is created from existing draft waypoint(s)
     */
    NotificationEvent["WAYPOINT_CREATED"] = "notif_waypointCreated";
    /**
     * Triggered when Waypoint.status.status === 'transitWaypoint'
     * Used to send a notification to the nurse when they arrive at the waypoint
     */
    NotificationEvent["WAYPOINT_START"] = "notif_waypointStart";
})(NotificationEvent || (NotificationEvent = {}));
/**
 * The subset of `NotificationEvent` enum related to order
 * intake notifications
 */
export const OrderIntakeNotificationEvents = [
    NotificationEvent.ORDER_INITIATED,
    NotificationEvent.ORDER_SUBMITTED,
    NotificationEvent.ORDER_CANCELED,
];
/**
  * The subset of `NotificationEvent` enum related to
  * fulfillment update notifications
  */
export const FulfillmentNotificationEvents = [
    NotificationEvent.VISIT_SCHEDULED,
    NotificationEvent.PROCEDURE_COMPLETED,
    NotificationEvent.SAMPLES_SUBMITTED,
    NotificationEvent.SAMPLES_DELIVERED,
];
/**
  * The subset of `NotificationEvent` enum that are used for subscription
  * notifications
  */
export const SubscriptionNotificationEvents = [
    ...OrderIntakeNotificationEvents,
    ...FulfillmentNotificationEvents,
];
//# sourceMappingURL=notifications.js.map